var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"ws-page"},[_c('header',{staticClass:"ws-page-header"},[_c('h1',{staticClass:"ws-page-header__title has-text-weight-bold is-size-2",domProps:{"textContent":_vm._s(_vm.$t('Эксперты'))}})]),_c('ws-experts-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }